import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from "./User/pages/Home.js";
import Categories from "./User/pages/Categories.js";
import Product from "./User/pages/Product.js";
import Profile from "./User/pages/Profile.js";
import Overview from "./User/components/Overview.jsx";
import Account from "./User/components/Account.jsx";
import Catalogue from "./User/pages/Catalogue.js";
import Address from './User/components/Address.jsx';
import Addaddress from "./User/components/Add_address.jsx";
import Myinteraction from "./User/components/My_Interaction.jsx";
import Mycart from "./User/components/My_cart.jsx";
import Catalogueorder from './User/components/Catalogue_order.jsx';
import Pickuporder from "./User/components/Pickup_order.jsx";
import Myorders from "./User/components/My_orders.jsx";
import Mynotifications from "./User/components/My_notifications.jsx";
import Aboutus from "./User/pages/About_us.js";
import Faqs from "./User/pages/Faq's.js";
import Termsconditions from "./User/pages/Terms_conditions.js";
import Privacypolicy from "./User/pages/Privacy_policy.js";
import ScrollToTop from "./User/components/ScrollToTop.jsx";
import Admindashboard from './Admin/pages/AdminDashboard.js';
import AdminNotifications from './Admin/pages/Notifications.js';
import Adminlogin from './Admin/pages/Login.js';
import Adminsidebar from './Admin/layouts/Sidebar.jsx';
import Admincatalogue from './Admin/pages/Catalogue.js'
import AdminForgotPassword from "./Admin/pages/AdminForgotPassword.js";
import AdminProduct from './Admin/pages/Product.js'
import ProductSubcategory from "./Admin/pages/ProductSubcategory.js";
import Orders from "./Admin/pages/Orders.js";
import Consultation from "./Admin/pages/Consultation.js";
import Delivers from "./Admin/pages/Delivers.js";
import Users from "./Admin/pages/Users.js";
import Banners from "./Admin/pages/Banners.js";
import Employees from "./Admin/pages/Employees.js";
import Settings from "./Admin/pages/Settings.js";
// import Support from "./Admin/pages/Support.js";
import AdminCategory from "./Admin/pages/AdminCategory.js";
import Design from "./Admin/pages/Design.js";
import DesignType from "./Admin/pages/DesignType.js";
import SubCategory from "./Admin/pages/SubCategory.js";
import Login from './User/components/Login.jsx';
import Suborders from "./Admin/pages/Sub_orders.js";
import Addtocart from "./Admin/pages/Add_to_cart.js";
import Payment from "./Admin/pages/Payment.js";
import ApprovePay from "./User/components/ApprovePay.jsx";
import ApprovedOrderDetails from "./User/components/ApprovedOrderDetails.jsx";
import Consultationfor from "./User/components/Consultation_for.jsx";
import ThankYou from "./User/pages/ThankYou.js";
import Shippingpolicy from "./User/pages/Shipping_policy.js";
import Refundcancellation from "./User/pages/Refund_cancellation.js";
import Contactus from "./User/pages/Contact_us.js";
// import EmployeeTable from "./Admin/pages/Tailor.js";
import OrderInfoPage from './Admin/components/Order_info.jsx'
import Staff from "./Admin/pages/Staff.js";
import OrderDetails from "./User/components/Order_details.jsx";
import SubOrder_info from "./Admin/components/SubOrder_info.jsx";
import Reports from "./Admin/pages/Reports.js";
import Reports_component from "./Admin/components/Reports_component.jsx";
import { messaging, onMessageListener, requestForToken } from "./firebase.js";
import { onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import AccessiblePages from "./Admin/pages/Accessible_Pages.js";
import Makepayment from "./User/pages/Make_payment.js";

import { useLocation } from "react-router-dom";
import Makeconsultation from "./User/pages/Make_consultation.js";



const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token"); // Authentication logic
  const [isLoginModalOpen, setLoginModalOpen] = useState(!token); // Open dialog if no token

  const handleCloseLoginModal = () => {
    setLoginModalOpen(false);
  };

  if (!token) {
    return (
      <>
        <Login
          isLoginModalOpen={isLoginModalOpen}
          handleCloseLoginModal={handleCloseLoginModal}
        />
        {!isLoginModalOpen && <Navigate to="/" replace />}
      </>
    );
  }

  return children;
};


//userroutes
function UserRoutes() {

  return (
    <>
      <Routes>
        <Route index element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/catalogue' element={<Catalogue />} />
        <Route path='/Categories' element={<Categories />} />
        <Route path='/product/:id' element={<ProtectedRoute><Product /></ProtectedRoute>} />
        <Route path='/about' element={<Aboutus />} />
        <Route path='/faq' element={<Faqs />} />
        <Route path='/termsconditions' element={<Termsconditions />} />
        <Route path='/privacypolicy' element={<Privacypolicy />} />
        <Route path='/shippingpolicy' element={<Shippingpolicy />} />
        <Route path='/refundcancellation' element={<Refundcancellation />} />
        <Route path='/contactus' element={<Contactus />} />
        <Route path='/mycart' element={<ProtectedRoute><Mycart /></ProtectedRoute>} />
        <Route path='/profile' element={<ProtectedRoute><Profile /></ProtectedRoute>}>
          <Route path='' element={<Navigate to='/profile/overview' />} />
          {/* <Route path='/profile/overview' element={<Overview />} /> */}
          <Route path='/profile/account' element={<Account />} />
          <Route path='/profile/address' element={<Address />} />
          <Route path='/profile/addadress/:id' element={<Addaddress />} />
          <Route path='/profile/addadress' element={<Addaddress />} />
          <Route path='/profile/myinteraction' element={<Myinteraction />} />
          {/* <Route path='/profile/mycart' element={<Mycart />} /> */}
          <Route path='/profile/pickuporder' element={<Pickuporder />} />
          <Route path='/profile/catalogueorder' element={<Catalogueorder />} />
          <Route path='/profile/orders-details/:orderId' element={<OrderDetails />} />
          <Route path='/profile/myorders' element={<Myorders />} />
          <Route path='/profile/mynotifications' element={<Mynotifications />} />
          <Route path='/profile/approve-pay' element={<ApprovePay />} />
          <Route path='/profile/approve-pay/approved-order-details/:id' element={<ApprovedOrderDetails />} />
          <Route path='/profile/forconsultation-details/:id' element={<Consultationfor />} />
        </Route>
        <Route path='/thankyou' element={<ThankYou />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </>
  )
}


//adminroutes
function AdminRoutes() {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem("role");
  let authorization = false;
  if (token) {
    authorization = true;
  }
  return (
    <>
      <Routes>
        <Route path='/' element={<Adminsidebar />} >
          <Route path='/dashboard' element={<Admindashboard />} />
          {/* <Route path='/catalogue' element={<Admincatalogue />} /> */}
          <Route path='/category' element={<AdminCategory />} />
          <Route path='/subcategory' element={<SubCategory />} />
          <Route path='/design' element={<Design />} />
          <Route path='/designtype' element={<DesignType />} />
          <Route path='/product' element={<AdminProduct />} />
          <Route path='/product/:id' element={<ProductSubcategory />} />
          <Route path='/orders' element={<Orders />} />
          <Route path="/orderinfo/:order_id" element={<OrderInfoPage />} />
          <Route path='/orders/:categoryId' element={<Orders />} />
          {authorization === true && role === 'JuniorDesigner' && <Route path='/suborders' element={<Suborders />} />}
          {authorization === true && role === 'JuniorDesigner' && <Route path='/subordersinfo/:order_id' element={<SubOrder_info />} />}
          <Route path='/suborders/:categoryId' element={<Suborders />} />
          {/* <Route path='/payments' element={<Payment />} /> */}
          <Route path='/consultation' element={<Consultation />} />
          <Route path='/consultation/:categoryId' element={<Consultation />} />
          {/* <Route path='/delivers' element={<Delivers />} /> */}
          <Route path='/users' element={<Users />} />
          <Route path='/addtocart/:customerId' element={<Addtocart />} />
          {authorization === true && (role === 'Admin' || role === 'SeniorDesigner') && <Route path='/banners' element={<Banners />} />}
          {authorization === true && (role === 'Admin' || role === 'SeniorDesigner') && <Route path='/Notifications' element={<AdminNotifications />} />}
          {authorization === true && (role === 'Admin' || role === 'SeniorDesigner') && <Route path='/employees' element={<Employees />} />}
          <Route path='/staff' element={<Staff />} />
          {authorization === true && (role === 'Admin' || role === 'SeniorDesigner') && <Route path='/Reports' element={<Reports />} />}
          {authorization === true && (role === 'Admin' || role === 'SeniorDesigner') && <Route path='/Reports/:type' element={<Reports_component />} />}
          {authorization === true && (role === 'Admin') && <Route path='/Access' element={<AccessiblePages />} />}
          {/* <Route path='/support' element={<Support />} /> */}
          {/* <Route path='/orderassign' element={<EmployeeTable />} /> */}
          <Route path='/settings' element={<Settings />} />

        </Route>
      </Routes>
    </>
  )
}


function App() {
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [auth, setAuth] = useState({
    token: localStorage.getItem("token"),
    role: localStorage.getItem("role"),
  });
  // const [payloadRecived, setPayload] = useState();
  const location = useLocation();
  useEffect(() => {
    requestForToken();
  }, []);

  // onMessage(messaging, (payload) => {
  //   setPayload(payload)
  //   toast.success(payload?.notification?.body)
  //   console.log('message recived', payload);
  // });
  // console.log(payloadRecived);


  // useEffect(() => {
  //   onMessageListener()
  //     .then((payload) => {
  //       console.log("📩 Foreground notification: ", payload);

  //       if (Notification.permission === "granted") {
  //         new Notification(payload.notification.title, {
  //           body: payload.notification.body,
  //           icon: "/logo192.png",
  //         });
  //       }
  //     })
  //     .catch((err) => console.log("Failed: ", err));
  // }, []);



  useEffect(() => {
    const handleStorageChange = () => {
      setAuth({
        token: localStorage.getItem("token"),
        role: localStorage.getItem("role"),
      });
    };
    if (triggerRefresh === true) {
      handleStorageChange();
      setTriggerRefresh(false)
    }
  }, [triggerRefresh, setTriggerRefresh]);


  if (auth.token && (auth.role === "Admin" || auth.role === "JuniorDesigner" || auth.role === "SeniorDesigner")) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="*" element={<Navigate to={"/admin/dashboard"} />} />
        <Route path="/admin/login" replace element={<Navigate to={"/admin/dashboard"} />} />
        <Route path="/admin/forgotPassword" replace element={<Navigate to={"/admin/dashboard"} />} />
      </Routes>
    );
  }


  return (
    <ScrollToTop>
      <Routes>
        <Route index element={<Navigate to={"/home"} />} />
        <Route path="*" element={<UserRoutes />} />
        <Route path="/admin/login" element={<Adminlogin setTriggerRefresh={setTriggerRefresh} />} />
        {/* <Route path="/admin/*" element={<Navigate to={"/admin/dashboard"} />} /> */}
        <Route path="/admin/*" element={<Navigate to={"/admin/login"} />} />
        <Route path="/admin/forgotPassword" element={<AdminForgotPassword />} />
        <Route path='/thankyou' element={<ThankYou />} />
        <Route path='/makePayment/:orderId' element={<Makepayment />} />
        <Route path='/makeConsultation/:id' element={<Makeconsultation />} />
      </Routes>
    </ScrollToTop>
  );
}

export default App;
